import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { Link, useHistory, useParams } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Checkbox,
    Button,
    Typography,
    Box,
    InputLabel,
    Tooltip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Modal
} from '@material-ui/core';

import { Info } from '@material-ui/icons'

import './SelectService.scss'

import {
    Navbar,
    Header,
    StepHeader,
    FormBox,
    BootstrapInput,
    Footer
} from '../../components/_index'
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import { useYupValidationResolver } from '../../YupValidationResolver';
import { isObjectEmpty, transPasiiToRenewalData, transPasiiToReplacementData, transPasiiToDuplicateData, checkIfRedirect } from '../../utils';
import Scroll from 'react-scroll';
import errorWarning from '../../images/icon_warning.gif'

export default withTranslation()(function Home({t, i18n}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data, emptyData } = useData();
    const history = useHistory();
    const [ customError, setCustomError ] = useState([]);
    const [ renewError, setRenewError ] = useState(false);

    const particularsApplicantURL = `${process.env.REACT_APP_SUB_ROUTE}/particularsApplicant`;
    const personalInfoURL = `${process.env.REACT_APP_SUB_ROUTE}/personalInfo`;
    const enquiryStatusURL = `${process.env.REACT_APP_SUB_ROUTE}/enquiryStatus`;
    const vehicleDetailURL = `${process.env.REACT_APP_SUB_ROUTE}/vehicleDetail`;
    const applicationDetailURL = `${process.env.REACT_APP_SUB_ROUTE}/applicationDetail`;

    const getOldApplicationURL = `${window.location.origin}/EPASService/application/getOldApplication`;

    const schema = yup.object().shape({
        applicationType: yup.string().required(t("errors.frontend.790-E-0001")),
        onlineAppNo: yup.string().when('applicationType', {
            is: (val) => val === 'Enquiry',
            then: yup.string().required(t("errors.frontend.790-E-0002")),
            otherwise: yup.string().notRequired()
        }),
        appRefNo: yup.string().when('applicationType', {
            is: (val) => val === 'Renew' || val === 'Replace' || val === 'Duplicate',
            then: yup.string().required(t("errors.frontend.790-E-0003")),
            otherwise: yup.string().notRequired()
        }),
        serialNoPermit: yup.string().when('applicationType', {
            is: (val) => val === 'Renew' || val === 'Replace' || val === 'Duplicate',
            then: yup.string().required(t("errors.frontend.790-E-0004")),
            otherwise: yup.string().notRequired()
        }),
        vehicleRegisMark: yup.string().when('applicationType', {
            is: (val) => val === 'Renew' || val === 'Replace' || val === 'Duplicate' || val === 'Enquiry',
            then: yup.string().required(t("errors.frontend.790-E-0005")),
            otherwise: yup.string().notRequired()
        }),
        email: yup.string().when('applicationType', {
            is: (val) => val === 'Enquiry',
            then: yup.string().email(t("errors.frontend.790-E-0006")).required(t("errors.frontend.790-E-0007")),
            otherwise: yup.string().notRequired()
        }),
    })

    const {
        register,
        handleSubmit,
        control,
        watch,
        errors
    } = useForm({
        defaultValues: {
            siteIDNumber: data.siteIDNumber,
            applicationType: 'New',
            onlineAppNo: data.onlineAppNo,
            appRefNo: data.appRefNo,
            serialNoPermit: data.serialNoPermit,
            vehicleRegisMark: data.vehicleRegisMark,
            email: data.email,
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });

    useEffect(() => {
        scroll.scrollToTop();
        checkIfRedirect(data, history);
    }, [])

    const applictionTypeSelected = watch('applicationType');

    const [noFoundOpen, setNoFoundOpen] = useState(false);

    const handleYes = () => {
        if(process.env.REACT_APP_ENV_TYPE === "GNET"){
            emptyData();
            history.push(personalInfoURL);
        }
        else{
            emptyData();
            history.push(particularsApplicantURL);
        }
    }

    const onSubmit = (formData) => {
        console.log("formData: ", formData);
        let customErrorTmp = new Object();

        emptyData();
        sessionStorage.removeItem("renewalData");
        if(process.env.REACT_APP_ENV_TYPE == "GNET"){
            setValues({...formData, applicantType: "Government"});
        } else {
            setValues(formData)
        }
        
        if (applictionTypeSelected === 'Renew') {
            handleRenewal(formData);
        } else if (applictionTypeSelected === 'Replace') {
            handleReplacement(formData);
        } else if (applictionTypeSelected === 'Duplicate') {
            handleDuplicate(formData);
        } else if (applictionTypeSelected === 'Enquiry') {
            let url = `${window.location.origin}/EPASService/application/enquiryStatus`;
            let postOption = {
                method: 'POST',
                body: JSON.stringify({onlineAppNo: formData.onlineAppNo, vehicleRegisMark: formData.vehicleRegisMark, email: formData.email})
            };
            fetch(url, postOption)
            .then((response)=>(response.json()))
            .then((jsonObj)=>{
                if(!jsonObj.error&&!isObjectEmpty(jsonObj.data)){
                    setValues(jsonObj.data[0]);
                    history.push(enquiryStatusURL);
                } else {
                    console.log("enquiryStatus error: ", jsonObj.error)
					customErrorTmp["onlineAppNo"] = {"message": t("errors.frontend.790-E-0009")};
					setCustomError(customErrorTmp);
					onCustomError(customErrorTmp);
                }
            })
			.catch((error) => {
				console.log('error', error);
				customErrorTmp["onlineAppNo"] = {"message": t("errors.frontend.790-E-0010")};
				setCustomError(customErrorTmp);
				onCustomError(customErrorTmp);
			});
        } else {
            if(process.env.REACT_APP_ENV_TYPE === "GNET"){
                history.push(personalInfoURL);
            }
            else{
                history.push(particularsApplicantURL);
            }
        }
    };

    const onError = (errors) => {
        setCustomError([]);
        scroll.scrollToTop();
    }

    const onCustomError = (error) => {
        scroll.scrollToTop();
		console.log(error);
    }

    const handleRenewal = (formData) => {
        //fetch to the epas permit checking api
        fetch(getOldApplicationURL,{
            method: 'POST',
            body: JSON.stringify({appRefNo: formData.appRefNo, serialNoPermit: formData.serialNoPermit, vehicleRegisMark: formData.vehicleRegisMark})
        })
        .then((response)=>response.json())
        .then((jsonResponse)=>{
            let jsonData = JSON.parse(jsonResponse.data);
            console.log("JSON DATA: >>>>>>>>>>>>", jsonData);
            if(jsonData.code!==0){
                setRenewError(true);
            } else {
                let renewalData = transPasiiToRenewalData(jsonData, formData.serialNoPermit);
                console.log("RENEW DATA: >>>>>>>>>>", renewalData);
                console.log("ENV: >>>>>>>", process.env.REACT_APP_ENV_TYPE);
                if(!isObjectEmpty(renewalData)){
                    if(process.env.REACT_APP_ENV_TYPE === "PUBLIC"){
                        if(renewalData.applicantType==="Government"){
                            setRenewError(true);
                        } else {
                            setValues(renewalData);
                            history.push(personalInfoURL);
                        }
                    }
                    else if(process.env.REACT_APP_ENV_TYPE === "GNET"){
                        if(renewalData.applicantType!=="Government"){
                            setRenewError(true);
                        } else {
                            setValues(renewalData);
                            history.push(personalInfoURL);
                        }
                    }
                }
            }
        })
        .catch(console.log);
    }

    const handleRenewalYes = () => {
        if(process.env.REACT_APP_ENV_TYPE === "GNET"){
            history.push(personalInfoURL);
        }
        else{
            history.push(particularsApplicantURL);
        }
    }

    const handleReplacement = (formData) => {
        //fetch to the epas permit checking api
        fetch(getOldApplicationURL,{
            headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                },
            method: 'POST',
            body: JSON.stringify({appRefNo: formData.appRefNo, serialNoPermit: formData.serialNoPermit, vehicleRegisMark: formData.vehicleRegisMark})
        })
        .then((response)=>response.json())
        .then((jsonResponse)=>{
            let jsonData = JSON.parse(jsonResponse.data);
            if(jsonData.code!==0){
                setRenewError(true);
            } else {
                let renewalData = transPasiiToReplacementData(jsonData, formData.serialNoPermit);
                // let renewalData = transPasiiToDuplicateData(jsonData, formData.serialNoPermit);
                if(!isObjectEmpty(renewalData)){
                    if(process.env.REACT_APP_ENV_TYPE === "PUBLIC"){
                        if(renewalData.applicantType==="Government"){
                            setRenewError(true);
                        } else {
                            setValues(renewalData);
                            history.push(vehicleDetailURL);
                        }
                    }
                    else if(process.env.REACT_APP_ENV_TYPE === "GNET"){
                        if(renewalData.applicantType!=="Government"){
                            setRenewError(true);
                        } else {
                            setValues(renewalData);
                            history.push(vehicleDetailURL);
                        }
                    }
                }
            }
        })
        .catch(console.log);
    }

    const handleDuplicate = (formData) => {
        //fetch to the epas permit checking api
        fetch(getOldApplicationURL,{
            headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                },
            method: 'POST',
            body: JSON.stringify({appRefNo: formData.appRefNo, serialNoPermit: formData.serialNoPermit, vehicleRegisMark: formData.vehicleRegisMark})
        })
        .then((response)=>response.json())
        .then((jsonResponse)=>{
            let jsonData = JSON.parse(jsonResponse.data);
            if(jsonData.code!==0){
                setRenewError(true);
            } else {
                let renewalData = transPasiiToDuplicateData(jsonData, formData.serialNoPermit);
                if(!isObjectEmpty(renewalData)){
                    setValues(renewalData);
                    history.push(applicationDetailURL);
                }
            }
        })
        .catch(console.log);
    }

    const handleCloseRenewError = ()=>{
        setRenewError(false)
    }

    console.log("errors: ", errors);
    console.log('custom error: ', customError);
    console.log("data: ", data);

    //change language
    const supportedLanguages = ["en", "tc"];
    const { lang } = useParams();
    console.log("lang: ", lang);
    console.log("i18n.language: ", i18n.language);
    if(i18n.language!==lang&&supportedLanguages.includes(lang)){
        console.log("changing language to: ", lang);
        i18n.changeLanguage(lang)
    }

    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-001'}</title>
            </Helmet>
            <Box className="wrapper">
                <Header langLock/>
                <Box className="mainWrapper">
                    <Navbar step="step1" />
                    <Box className="contentWrapper">
                    <Dialog 
                    open={renewError}
                    onClose={handleCloseRenewError}
                    >
                        <DialogTitle id="alert-dialog-title">{t("incorrectInputData.title")}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {t("incorrectInputData.content")}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseRenewError} color="secondary" autoFocus>
                                {t("incorrectInputData.cancel")}
                            </Button>
                            <Button onClick={handleRenewalYes} color="primary">
                                {t("incorrectInputData.yes")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <ErrorsContainer errors={{...errors, ...customError}} />
                        <StepHeader
                            step="common.step1"
                            title="common.step1Title"
                            mandatory
                        />
                        <form onSubmit={handleSubmit(onSubmit, onError)} noValidate>
                            <FormBox header="step1.applicationType.title">
                                <Box
                                    p={5}
                                >
                                    <FormControl>
                                        <BootstrapInput
                                            name="siteIDNumber"
                                            id="siteIDNumber"
                                            hidden
                                            value={siteID()}
                                            inputRef={register}
                                        />
                                    </FormControl>
                                    <FormControl
                                        component="fieldset"
                                        error={!!errors.applicationType}
                                    >
                                        <legend className="hiddenLegend">{t('step1.applicationType.title')}</legend>
                                        <Controller
                                            control={control}
                                            name="applicationType"
                                            defaultValue={applictionTypeSelected}
                                            as={
                                                <RadioGroup
                                                    aria-label="applicationType"
                                                >
                                                    <FormControlLabel
                                                        value="New"
                                                        control={<Radio />}
                                                        label={t('step1.applicationType.applicationTypeOpt1')}
                                                    />
                                                    <FormControlLabel
                                                        value="Renew"
                                                        control={<Radio />}
                                                        label={t('step1.applicationType.applicationTypeOpt2')}
                                                    />
                                                    <FormControlLabel
                                                        value="Replace"
                                                        control={<Radio />}
                                                        label={t('step1.applicationType.applicationTypeOpt3')}
                                                    />
                                                    {
                                                        process.env.REACT_APP_PHASE==="1" &&
                                                        <FormControlLabel
                                                            value="Duplicate"
                                                            control={<Radio />}
                                                            label={t('step1.applicationType.applicationTypeOpt4')}
                                                        />
                                                    }
                                                    <FormControlLabel
                                                        value="Enquiry"
                                                        control={<Radio />}
                                                        label={t('step1.applicationType.applicationTypeOpt5')}
                                                    />
                                                </RadioGroup>
                                            }
                                        />
                                    </FormControl>
                                </Box>
                            </FormBox>
                            {
                                (applictionTypeSelected === 'Renew' ||
                                applictionTypeSelected === 'Replace' ||
                                applictionTypeSelected === 'Duplicate' ||
                                applictionTypeSelected === 'Enquiry') &&
                                    <FormBox header="step1.applicationInfo.title">
                                        <Box
                                            p={5}
                                        >
                                            {
                                                applictionTypeSelected === 'Renew' ?
                                                    <Typography variant="body1" className="formBoxDesc">{t('step1.applicationInfo.desc1')}</Typography>
                                                :
                                                applictionTypeSelected === 'Replace' ?
                                                    <Typography variant="body1" className="formBoxDesc">{t('step1.applicationInfo.desc2')}</Typography>
                                                :
                                                applictionTypeSelected === 'Duplicate' ?
                                                    <Typography variant="body1" className="formBoxDesc">{t('step1.applicationInfo.desc3')}</Typography>
                                                :
                                                applictionTypeSelected === 'Enquiry' ?
                                                    <Typography variant="body1" className="formBoxDesc">{t('step1.applicationInfo.desc4')}</Typography>
                                                :
                                                ""
                                            }
                                            {
                                                applictionTypeSelected === 'Enquiry' &&
                                                    <Box mb={6}>
                                                        <FormControl
                                                            error={!!errors.onlineAppNo}
                                                        >

                                                            <InputLabel shrink htmlFor="onlineAppNo">
                                                                {t('step1.applicationInfo.onlineAppNo')}
                                                                <Box ml={2}>
                                                                    <Tooltip
                                                                        title={t('step1.applicationInfo.onlineAppNoDesc')}
                                                                        aria-label="info"
                                                                        arrow
                                                                        enterTouchDelay={0}
                                                                        leaveTouchDelay={3000}
                                                                    >
                                                                        <Info fontSize="small" />
                                                                    </Tooltip>
                                                                </Box>
                                                                    {(!!errors.onlineAppNo) ? <img id="onlineAppNo_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                                    {(!!customError.onlineAppNo) && !(!!errors.onlineAppNo) ? <img id="onlineAppNo_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                            </InputLabel>

                                                            <BootstrapInput
                                                                id="onlineAppNo"
                                                                name="onlineAppNo"
                                                                defaultValue={data.onlineAppNo}
                                                                ref={register}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                            }
                                            {
                                                (applictionTypeSelected === 'Renew' ||
                                                applictionTypeSelected === 'Replace' ||
                                                applictionTypeSelected === 'Duplicate') &&
                                                    <>
                                                        <Box mb={6}>
                                                            <FormControl
                                                                error={!!errors.appRefNo}
                                                            >

                                                                <InputLabel shrink htmlFor="appRefNo">
                                                                    {t('step1.applicationInfo.appRefNo')}
                                                                    <Box ml={2}>
                                                                        <Tooltip
                                                                            title={t('step1.applicationInfo.appRefNoDesc')}
                                                                            aria-label="info"
                                                                            arrow
                                                                            enterTouchDelay={0}
                                                                            leaveTouchDelay={3000}
                                                                        >
                                                                            <Info fontSize="small" />
                                                                        </Tooltip>
                                                                    </Box>
                                                                        {!!errors.appRefNo ? <img id="appRefNo_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                                </InputLabel>

                                                                <BootstrapInput
                                                                    id="appRefNo"
                                                                    name="appRefNo"
                                                                    defaultValue={data.appRefNo}
                                                                    ref={register}
                                                                />
                                                            </FormControl>
                                                        </Box>
                                                        <Box mb={6}>
                                                            <FormControl
                                                                error={!!errors.serialNoPermit}
                                                            >
                                                                <InputLabel shrink htmlFor="serialNoPermit">
                                                                    {t('step1.applicationInfo.serialNoPermit')}
                                                                    <Box ml={2}>
                                                                        <Tooltip
                                                                            title={t('step1.applicationInfo.serialNoPermitDesc')}
                                                                            aria-label="info"
                                                                            arrow
                                                                            enterTouchDelay={0}
                                                                            leaveTouchDelay={3000}
                                                                        >
                                                                            <Info fontSize="small" />
                                                                        </Tooltip>
                                                                    </Box>

    																	{!!errors.serialNoPermit ? <img id="serialNoPermit_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                                </InputLabel>

                                                                <BootstrapInput
                                                                    id="serialNoPermit"
                                                                    name="serialNoPermit"
                                                                    defaultValue={data.serialNoPermit}
                                                                    ref={register}
                                                                />
                                                            </FormControl>
                                                        </Box>
                                                    </>
                                            }
                                            <Box mb={6}>
                                                <FormControl
                                                    error={!!errors.vehicleRegisMark}
                                                >
                                                    <InputLabel shrink htmlFor="vehicleRegisMark">
                                                        {t('step1.applicationInfo.vehicleRegisMark')}
                                                        <Box ml={2}>
                                                            <Tooltip
                                                                title={t('step1.applicationInfo.vehicleRegisMarkDesc')}
                                                                aria-label="info"
                                                                arrow
                                                                enterTouchDelay={0}
                                                                leaveTouchDelay={3000}
                                                            >
                                                                <Info fontSize="small" />
                                                            </Tooltip>
                                                        </Box>
                                                        {!!errors.vehicleRegisMark ? <img id="vehicleRegisMark_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                    </InputLabel>

                                                    <BootstrapInput
                                                        id="vehicleRegisMark"
                                                        name="vehicleRegisMark"
                                                        defaultValue={data.vehicleRegisMark}
                                                        ref={register}
                                                    />
                                                </FormControl>
                                            </Box>
                                            {
                                                applictionTypeSelected === 'Enquiry' &&
                                                <Box mb={6}>
                                                    <FormControl
                                                        error={!!errors.email}
                                                    >
                                                        <InputLabel shrink htmlFor="email">
                                                            {t('step1.applicationInfo.email')}
                                                            {!!errors.email ? <img id="email_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                        </InputLabel>
                                                        <BootstrapInput
                                                            id="email"
                                                            name="email"
                                                            defaultValue={data.email}
                                                            ref={register}
                                                        />
                                                    </FormControl>
                                                </Box>
                                            }
                                        </Box>
                                    </FormBox>
                            }
                            <FormBox>
                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                >
                                    <Button variant="contained" color="primary" type="submit">
                                        {t('common.button.next')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
            <Dialog
                open={noFoundOpen}
                onClose={()=>setNoFoundOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t('step1.dialog.notice')}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('step1.dialog.noticeMsg')}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={()=>setNoFoundOpen(false)} color="primary">
                {t('step1.dialog.no')}
                </Button>
                <Button onClick={handleYes} color="primary" autoFocus>
                    {t('step1.dialog.yes')}
                </Button>
                </DialogActions>
            </Dialog>
        </main>
    )
})
